import React from 'react'

export function Home() {
  return (
    <div>Estamos en la home</div>
  )
}
